export default __webpack_public_path__ + "static/media/representation.a1c46226.webp";